import { LocalizationProvider, MobileDatePicker } from '@mui/x-date-pickers'; 
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TextField } from '@mui/material'; 
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { Dayjs } from 'dayjs';
import es from 'dayjs/locale/es';

import './my-datepicker.css'

export interface MyDatePickerProps {
    labelText?: string;
    value?: Dayjs | null,
    minDate?: any;
    maxDate?: any;
    setSelectedDate?: (value: Dayjs | null) => void;
    disabled?: boolean;
    defaultLabel?: string;
}
const MyDatepicker = ({labelText, value, minDate, maxDate, setSelectedDate, disabled, defaultLabel, ...props}: MyDatePickerProps) => { 

    // const [minDate, setMinDate] = useState<any>(dayjs())
  
    return ( 
        <LocalizationProvider 
            dateAdapter={AdapterDayjs}
            adapterLocale={es.name}
        >
            {labelText && <label 
                style={{
                    color: "#666",
                    fontFamily: "Roboto",
                    fontSize: ".875rem",
                    fontStyle: "normal",
                    fontWeight: "500",
                    lineHeight: "normal",
                }}
            >
                {labelText}
            </label>}
            <MobileDatePicker
                disabled={disabled}
                minDate={minDate || undefined}
                maxDate={maxDate || undefined}
                onChange={(days: Dayjs | null) => {
                    if (setSelectedDate) {
                        setSelectedDate(days);
                    }
                }}
                label={defaultLabel}
                value={value}
                className='my-datepicker'
                slots={{
                  textField: textFieldProps => 
                    <TextField 
                        {...textFieldProps}
                        fullWidth
                        style={{marginTop: "0", }} 
                        InputProps={{
                            style: {height: "2.5rem !important",},
                            endAdornment: <CalendarTodayIcon />
                        }}
                        
                    />
                }}
                
            />
        </LocalizationProvider>
    ); 
} 


export default  MyDatepicker